<template>
  <div class="about">
    <h1>About this app ...</h1>
  </div>
</template>
